var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 28,
    viewBox: "0 0 60 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H41.2929L31.3405 9.95236L18.7961 7.16471C18.5554 7.06015 18.2901 7.00156 18.0112 7.00003C18.0039 6.99986 17.9965 6.99985 17.9892 7H11C10.6357 7 10.2942 7.09739 10 7.26756V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02791 8.66513C9.00983 8.61344 9 8.55787 9 8.5V0.622681L0.123652 8.61139L9 25.4765V9C9 8.88589 9.00956 8.77402 9.02791 8.66513Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.809L0 23.309V28H9V27.809Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28H25.5998L20 23.6002V28Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.3284L27.2184 28H40V27.7235L31.1654 10.9379L19.9202 8.43891C19.9722 8.61693 20 8.80521 20 9V22.3284Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28H60V25.9236L51 19.0412V28Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17.7823L60 24.6647V11.3495L50.9832 8.73933C50.9943 8.82465 51 8.91166 51 9V17.7823Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5111 7C48.5035 6.99983 48.496 6.99983 48.4884 7H42.1697L42.9475 0H60V10.3084L50.3348 7.5106C49.9808 7.19311 49.513 7 49 7H48.5111Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1422 7.19279C40.4668 7.51393 40 8.20244 40 9V25.5765L32.114 10.5931L41.8456 0.861458L41.1422 7.19279Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33388 26.3579L0 22.191V10.5235L8.33388 26.3579Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19702 0L0 7.37732V0H8.19702Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.4cb46bb2bbd918d884fc3c6600d10f9d.svg";
export { ForwardRef as ReactComponent };